import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Browse from './pages/Browse';
import VideoDetail from './pages/VideoDetail';
import ArtistProfile from './pages/ArtistProfile';
import Profile from './pages/Profile';
import UserProfile from './pages/UserProfile';
import AdminDashboard from './pages/AdminDashboard';
import YouTubeImport from './pages/YouTubeImport';
import ArtistManagement from './pages/ArtistManagement';
import VideoUpload from './pages/VideoUpload';
import LiveStreamAdmin from './pages/LiveStreamAdmin';
import Rankings from './pages/Rankings';
import Login from './pages/Login';
import NotFound from './pages/NotFound';

function App() {
  useEffect(() => {
    // Disable browser's automatic scroll restoration
    // This prevents the browser from restoring scroll position from the previous page
    if (window.history.scrollRestoration) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <div className="min-h-screen bg-battle-dark flex flex-col">
          <Navbar />
          <main className="flex-1 pt-16">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/browse" element={<Browse />} />
              <Route path="/video/:id" element={<VideoDetail />} />
              <Route path="/rankings" element={<Rankings />} />
              <Route path="/artist/:id" element={<ArtistProfile />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/user/:id" element={<UserProfile />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/youtube-import" element={<YouTubeImport />} />
              <Route path="/admin/artists" element={<ArtistManagement />} />
              <Route path="/admin/upload" element={<VideoUpload />} />
              <Route path="/admin/live" element={<LiveStreamAdmin />} />
              <Route path="/login" element={<Login />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
